<template>
  <el-drawer
    :visible="visible"
    :size="systemCheck === 'ios' ? '29.5vh' : '20vh'"
    :with-header="false"
    append-to-body
    direction="btt"
    custom-class="download-drawer"
    @close="handleCancel"
  >
    <div class="drawer-content">
      <i
        class="iconfont el-icon-circle-close"
        :style="{
          color:
            systemCheck === 'ios' &&
            packageConfig.iosType === 'PACK_TYPE_DESKTOP_QUICK'
              ? '#666'
              : '#fff',
        }"
        @click="handleCancel"
      />
      <template
        v-if="
          packageConfig.iosType !== 'PACK_TYPE_DESKTOP_QUICK' ||
          systemCheck !== 'ios'
        "
      >
        <div class="drawer-body">
          <img class="android-img" :src="logo" />
          <span>{{ $t("Datalang.click_desktop") }}</span>
        </div>

        <div class="drawer-footer">
          <el-button class="drawer-button" @click="handleCancel(true)">
            {{ $t("Datalang.Signin_TITLE_cancel") }}
          </el-button>
          <el-button class="drawer-button" @click="downloadApp">
            {{ $t("Datalang.HomePage_BTM_download") }}
          </el-button>
        </div>
      </template>

      <template
        v-if="
          systemCheck === 'ios' &&
          packageConfig.iosType === 'PACK_TYPE_DESKTOP_QUICK'
        "
      >
        <div class="ios-drawer-body">
          <!-- <div class="ios-title">
            <span>{{ $t("Datalang.Click_Add_to") }}</span>
            <span>{{ $t("Datalang.Save_web_version") }}</span>
          </div> -->
          <img class="ios-img" :src="getIOSimg" alt="" />
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import { cocosDownload } from "@/lobby_common/utils/appPostMessage.js";
import { locationJump } from "@/lobby_common/utils/eventFunction.js";
// import { isMobile, opacityPage } from "@/lobby_common/utils/utils.js";
// import { dynamicCreateManifest } from "@/lobby_common/utils/dynamicCreateManifest";
export default {
  props: {
    visible: {
      type: Boolean,
    },
    pwaIcon: {
      type: String,
    },
    systemCheck: {
      type: String,
    },
    type: {
      type: String,
      // h5RechargeLimit
    },
  },
  data() {
    return {
      userType: "ios",
      // systemCheck: "",
      packageConfig: this.$store.getters.getPacketConfig?.site || {},
      deferredPropmpt: null,
    };
  },
  mounted() {
    window.addEventListener(
      "beforeinstallprompt",
      this.beforeinstallprompthandler
    );
    const system = this.systemCheack() || "Android";
    if (system === "Android") {
      this.userType = "andriod";
    }
    if (system === "ios") {
      this.userType = "ios";
    }

    // this.systemCheck =
    //   isMobile === "ios" &&
    //   this.packageConfig.iosType !== "PACK_TYPE_DESKTOP_QUICK";
  },
  computed: {
    logo() {
      return this.$utils.returnImgUrl(this.pwaIcon);
    },
    language() {
      return this.$store.getters.getLang || "en";
    },
    getIOSimg() {
      return require(`@/lobby_common/assets/pwaImg/ios_${this.language}.png`);
    },
    appSid() {
      return this.$store.getters.getPacketConfig?.appConfig?.sid;
    },
    ios() {
      const params = encodeURIComponent(`light=1&terminaltype=lightweight`);
      const obj = {
        name: "down.ios",
        link:
          this.packageConfig.iosType === "PACK_TYPE_LIGHT"
            ? this.$store.getters.getPacketConfig?.site?.iosAddr +
              `/adsevent/v1/download?jumper=true&appSid=${this.appSid}&uid=''&params=${params}`
            : this.$store.getters.getPacketConfig?.site?.iosAddr,
        id: 1,
      };
      return obj;
    },
    andriod() {
      const obj = {
        name: "down.andriod",
        // link: this.$store.getters.getPacketConfig?.site?.androidAddr || "",
        link:
          this.packageConfig.androidType !== "PACK_TYPE_DESKTOP_QUICK" ||
          this.systemCheck !== "ios"
            ? this.packageConfig.androidAddr
            : window.location.origin,
        id: 2,
      };

      return obj;
    },
  },
  methods: {
    // 检查系统是安卓还是ios
    systemCheack() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端.
      if (isAndroid) {
        return "Android";
      }
      if (isIOS) {
        return "ios";
      }
    },
    beforeinstallprompthandler(event) {
      event.preventDefault();
      this.deferredPropmpt = event;
      window.deferredPropmpt = event;
      console.log(this.deferredPropmpt, "deferredPropmpt");
    },

    downloadApp() {
      // const packageConfig = this.$store.getters.getPacketConfig?.site || {};
      let eventName = "";
      // if (
      //   this.userType === "ios" &&
      //   packageConfig.iosType === "PACK_TYPE_DESKTOP_QUICK"
      // ) {
      //   this.drawerVisible = true;
      //   return;
      // }

      // console.log(packageConfig.androidAddr, "11111111111111111111111");
      if (
        this.userType === "andriod" &&
        this.packageConfig.androidType === "PACK_TYPE_DESKTOP_QUICK"
      ) {
        this.handleClickToHome();
        return;
      }

      let url = this.andriod.link;
      let id = this.andriod.id;
      // console.log(this.ios, "this.andriod.link, this.andriod.id");
      eventName = "download_android";
      if (this.userType === "ios") {
        url = this.ios.link;
        id = this.ios.id;
        eventName = "download_ios";
      }

      const cur_url = this.codeFun(url);
      cocosDownload(cur_url);
      // window.location.href = cur_url;
      locationJump(cur_url);
      window.ttq?.track("Download");
      this.$eventPost(eventName);
    },

    codeFun(url) {
      if (!this.cur_invite_code) {
        return url;
      } else {
        if (url.indexOf("?") !== -1) {
          return url + "&uid=" + this.cur_invite_code;
        } else {
          return url + "?uid=" + this.cur_invite_code;
        }
      }
    },
    handleClickToHome() {
      // const packageConfig = this.$store.getters.getPacketConfig?.site || {};
      // dynamicCreateManifest(packageConfig ,'pwa');
      // const packageConfig = this.$store.getters.getPacketConfig?.site || {};
      console.log(this.deferredPropmpt, "this.deferredPropmpt==========");
      if (this.deferredPropmpt) {
        this.deferredPropmpt.prompt();
        this.deferredPropmpt.userChoice.then((res) => {
          if (res.outcome === "accepted") {
            console.log(" user accepted add to home screen");
            if (this.type !== "h5RechargeLimit") {
              localStorage.setItem("drawerClosed", true);
            }
            Notification.requestPermission().then((res) => {
              if (res === "granted") {
                // navigator.serviceWorker.ready.then((registration) => {
                //   registration.showNotification("标题", {
                //     body: "应用已添加到主屏幕，祝您游玩愉快！",
                //   });
                // });
              }
            });
          } else {
            // 设备支持，但可能用户拒绝
            console.log(" user dismissed add to home screen");
          }
          this.$emit("close", false);
        });
      } else {
        // 设备不支持
        this.$message({
          message: this.$t("Datalang.newly_device_unsupported"),
          type: "error",
          showClose: true,
        });
      }
    },
    handleCancel(isCancle) {
      if (isCancle === true) {
        this.$eventPost("Desktop_popup_cancel");
      } else {
        this.$eventPost("Desktop_popup_close");
      }
      this.$emit("close", false);
      if (this.type !== "h5RechargeLimit") {
        localStorage.setItem("drawerClosed", true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-content {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  // padding: 0px 12px 0px 12px;
  overflow-y: scroll;
  position: relative;

  .iconfont {
    position: absolute;
    right: 2vh;
    top: 2vh;
    z-index: 10;
    font-size: 24px;
  }
  .drawer-body {
    display: flex;
    align-items: center;
    padding: 0px 12px 0px 12px;
    .android-img {
      width: 60px;
      height: 60px;
      margin-right: 16px;
    }
  }
  .ios-drawer-body {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ios-title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      > span {
        &:first-child {
          font-size: 18px;
          margin-bottom: 4px;
        }
      }
    }
    .ios-img {
      width: 100%;
      height: 100%;
      margin-right: 0;
    }
  }
  .drawer-footer {
    align-self: flex-end;
    display: flex;
    justify-content: flex-end;
    margin: 0px 12px 12px 0px;
    .drawer-button {
      @include buttonPrimary;
      color: if(
        global-variable-exists("font-color-300"),
        $font-color-300,
        ""
      ) !important;
      width: 98px;
      transform: scale(1);
      transition: transform 0.15s all;
      &:active {
        transform: scale(1.08);
        transition: transform 0.15s all;
      }
    }
  }
}
</style>

<style lang="scss">
.download-drawer {
  .el-drawer__header {
    padding: 8px 0px 0px 0px;
    margin-bottom: 0px !important;
  }
}
</style>
